export const LOADER_STATUS = 'boilerplate/Gstr2a2bNew/Fetch/LOADER_STATUS';
export const VIEW_TABLE_DATA = 'boilerplate/Gstr2a2bNew/Fetch/VIEW_TABLE_DATA';
export const HISTORY_TABLE_DATA = 'boilerplate/Gstr2a2bNew/Fetch/HISTORY_TABLE_DATA';
export const TOTAL_PAGES_VIEW = 'boilerplate/Gstr2a2bNew/Fetch/TOTAL_PAGES_VIEW';
export const TOTAL_PAGES_HISTORY = 'boilerplate/Gstr2a2bNew/Fetch/TOTAL_PAGES_HISTORY';
export const SELECTED = 'boilerplate/Gstr2a2bNew/Fetch/SELECTED';
export const SELECT_UNIQUE = 'boilerplate/Gstr2a2bNew/Fetch/SELECT_UNIQUE';

export const headerColumns = [
  {
    value: "History",
    id: "1",
  },
  {
    value: "View",
    id: "2",
  },
];
export const fetchStatus = [
  {
    label: "Completed",
    value: "Completed",
  },
  {
    label: "Failed",
    value: "Failed",
  },
  // {
  //   label: "Not Initiated",
  //   value: "Not Initiated",
  // },
];

export const reportType = [
  {
    label: "GSTR-2A",
    value: "GSTR-2A",
  },
  {
    label: "GSTR-2B",
    value: "GSTR-2B",
  },
];
